
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import { applicantStatusNames, ApplicantStatus } from "@/entities/ApplicantStatus";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })

  export default class ApplicantStatusSelect extends Vue {
    @Prop({ type: Array, default: () => []}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
     @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    get statusOptions(): DropdownOption[] {
      return Object
        .entries(applicantStatusNames)
        .map(([status, value]) =>({
          name: value,
          id: status,
        }));
    }

    handleInput(input: DropdownOption): void {
      this.$emit('input', input);
      this.$emit('statusChosen');
    }
  }
